import { frontendURL } from '../../../helper/URLHelper';
import {
  LOCKED_FEATURES,
  LOCKED_FEATURE_KEYS,
  lockedFeatureRouteName,
} from '../../../constants/lockedFeatures';
import { REDIS_FEATURE_FLAGS } from '../../../featureFlags';
import store from '../../../store';

const LockedFeature = () => import('./LockedFeature.vue');

const isClaudiaOnlyAccount = accountId => {
  const isFeatureEnabled = store.getters['accounts/isFeatureEnabledonAccount'];
  return (
    typeof isFeatureEnabled === 'function' &&
    isFeatureEnabled(Number(accountId), REDIS_FEATURE_FLAGS.CLAUDIA_ONLY)
  );
};

// The upsell pages only make sense for accounts that cannot reach the real
// feature. A full account landing here (stale link, shared URL) would be asked
// to request something it already has, so send it to the dashboard instead.
const guardClaudiaOnly = (to, from, next) => {
  const { accountId } = to.params;
  if (isClaudiaOnlyAccount(accountId)) {
    next();
    return;
  }
  next(frontendURL(`accounts/${accountId}/dashboard`));
};

export default {
  routes: LOCKED_FEATURE_KEYS.map(feature => ({
    path: frontendURL(`accounts/:accountId/locked/${feature}`),
    name: lockedFeatureRouteName(feature),
    component: LockedFeature,
    beforeEnter: guardClaudiaOnly,
    meta: {
      permissions: ['administrator', 'agent', 'supervisor', 'cx_engineer'],
      lockedFeature: feature,
      title: LOCKED_FEATURES[feature].titleKey,
    },
  })),
};
